import React, { useState, useEffect } from "react";
import DynamicModal from "../shared/DynamicModal";
import moment from "moment";
import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBinLine } from "react-icons/ri";
import Modal from "../shared/Modal";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { MdKeyboardArrowRight } from "react-icons/md";
import CustomSelect from "../shared/CustomSelect";
import SuccessPopup from "../shared/SuccessPopup";
import { useLoading } from "../../context/LoadingContext";
import GlobalLoader from "../shared/GlobalLoader";
import { truncateText } from "../../utils/textTruncateUtils";
const NotificationTable = () => {
  const initialFormData = {
    dueDate: "",
    task: "",
    priority: "",
    status: "",
    description: "",
    additionalInfo: "",
  };
  const userDetails = JSON.parse(localStorage.getItem("userDetails") || "");
  const { isLoading, setLoading } = useLoading();
  const [tasks, setTasks] = useState([]); // State to store tasks
  const [isModalOpen, setIsModalOpen] = useState(false); // To control the popup visibility
  const [formData, setFormData] = useState(initialFormData);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState({
    type: "",
    show: false,
    message: ""
  });

  // Pagination and Sorting State
  const [sortedData, setSortedData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [rowsPerPage, setRowsPerPage] = useState(10); // Start with 10 rows per page by default
  const [currentPage, setCurrentPage] = useState(1);
  const baseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    fetchTasks();
  }, []);

  useEffect(() => {
    setSortedData([...tasks]); // Ensure sortedData is always in sync with tasks
  }, [tasks]);

  const fetchTasks = async () => {
    try {
      setLoading(true);
      const selectedLocationId = localStorage.getItem("selectedLocationId");
      const selectedSystemId = localStorage.getItem("selectedSystemId");
      const selectedCustomerId = localStorage.getItem("customerId");

      const accessToken = sessionStorage.getItem("accessToken");

      if (!selectedCustomerId || !selectedLocationId || !selectedSystemId) {
        console.error(
          "Missing required parameters: customerId, locationId, or systemId"
        );
        setLoading(false);
        return;
      }

      const headers = accessToken ? { Authorization: `${accessToken}` } : {};

      const url = `${baseUrl}/task?customerId=${selectedCustomerId}&locationId=${selectedLocationId}&systemId=${selectedSystemId}`;

      const response = await fetch(url, { headers });

      if (!response.ok) {
        throw new Error("Failed to fetch tasks");
      }
      const jsonData = await response.json();
      setTasks(jsonData);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      return null;
    }
  };

  // Sorting Logic
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedArray = [...tasks].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setSortedData(sortedArray);
    setSortConfig({ key, direction });
  };

  // Pagination Logic
  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to the first page when rows per page changes
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = sortedData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(sortedData.length / rowsPerPage);

  const deadlinesFields = [
    {
      id: "taskName",
      type: "text",
      name: "taskName",
      placeholder: "",
      label: "Task",
      required: true,
      position: 2,
    },
    {
      id: "dueDate",
      type: "date",
      name: "dueDate",
      placeholder: "",
      label: "Due Date",
      required: true,
      position: 1,
    },
    {
      id: "priority",
      type: "select",
      name: "priority",
      placeholder: "",
      label: "Priority",
      required: true,
      position: 3,
      options: [
        { value: "High", label: "High" },
        { value: "Medium", label: "Medium" },
        { value: "Low", label: "Low" },
      ],
    },
    {
      id: "status",
      type: "select",
      name: "status",
      placeholder: "",
      label: "Status",
      required: true,
      position: 4,
      options: [
        { value: "Late", label: "Late" },
        { value: "Pending", label: "Pending" },
        { value: "InProgress", label: "In Progress" },
        { value: "Closed", label: "Closed" },
      ],
    },
    {
      id: "description",
      type: "text",
      name: "description",
      placeholder: "",
      label: "Description",
      required: true,
      position: 5,
    },
  ];

  const deadlinesFieldsForamt = deadlinesFields.sort(
    (a, b) => a.position - b.position
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleCloseModal = () => {
    setFormData(initialFormData);
    setIsModalOpen(false);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const accessToken = sessionStorage.getItem("accessToken");
      const selectedLocationId = localStorage.getItem("selectedLocationId");
      const selectedSystemId = localStorage.getItem("selectedSystemId");
      const selectedCustomerId = localStorage.getItem("customerId");
      const headers = accessToken
        ? {
          Authorization: `${accessToken}`,
          "Content-Type": "application/json",
        }
        : { "Content-Type": "application/json" };

      const taskData = {
        taskName: formData?.task || formData?.taskName, // Task name
        description: formData.description, // Task description
        dueDate: formData.dueDate, // Ensure date is in "YYYY-MM-DD"
        priority: formData.priority, // Priority (e.g., High, Medium, Low)
        status: formData.status, // Task status (e.g., Pending, Completed)
        customerId: selectedCustomerId,
        locationId: selectedLocationId,
        systemId: selectedSystemId,
      };

      const url = formData.id
        ? `${baseUrl}/task/${formData.id}`
        : `${baseUrl}/task`;

      const method = formData.id ? "PUT" : "POST"; // Use PUT for updates

      const response = await fetch(url, {
        method,
        headers: headers,
        body: JSON.stringify(taskData),
      });

      if (response?.ok && method === "POST") {
        setShowSuccessPopup({
          type: "success",
          show: true,
          message: "Task Created Successfully",
        });
      }

      if (response?.ok && method === "PUT") {
        setShowSuccessPopup({
          type: "success",
          show: true,
          message: "Task Updated Successfully",
        });
      }

      if (!response.ok) {
        throw new Error("Failed to create task");
      }

      const newTask = await response.json();
      fetchTasks(); // Refresh tasks after saving
      handleCloseModal();
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handleEdit = (task) => {
    setFormData(task);
    setIsModalOpen(true);
  };

  const openDeleteModal = (taskId) => {
    setSelectedTaskId(taskId);
    setDeleteModalOpen(true);
  };

  const handleDelete = async () => {
    if (!selectedTaskId) return;
    try {
      setLoading(true);
      setDeleteModalOpen(false);
      const accessToken = sessionStorage.getItem("accessToken");
      const headers = accessToken ? { Authorization: `${accessToken}` } : {};

      await fetch(`${baseUrl}/task/${selectedTaskId}`, {
        method: "DELETE",
        headers,
      });

      setShowSuccessPopup({
        type: "success",
        show: true,
        message: "Task Deleted Successfully",
      });

      fetchTasks(); // Refresh tasks after deletion
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <div className="row theme-container rounded">
      {isLoading && <GlobalLoader />}
      <div className="col-12" style={{ overflowY: "auto" }}>
        <div className="col-12 d-flex align-items-center justify-content-between py-2">
          <div className="fnt14 fw-600">Tasks</div>
          <div>
            <button
              className="button-primary"
              onClick={() => setIsModalOpen(true)}
            >
              Create
            </button>
          </div>
        </div>

        <div
          className="table-container theme-container mt-2"
          style={{ overflowY: "auto" }}
        >
          <table className="table theme-container" style={{ width: "100%" }}>
            <thead>
              <tr
                className="fnt12"
                style={{
                  height: "18px",
                  textAlign: "left",
                  verticalAlign: "middle",
                }}
              >
                <th
                  style={{
                    width: "15%",
                    fontWeight: 600,
                    padding: "2px 4px",
                    verticalAlign: "middle",
                    cursor: "pointer",
                  }}
                  onClick={() => handleSort("dueDate")}
                >
                  Due Date{" "}
                  {sortConfig.key === "dueDate"
                    ? sortConfig.direction === "asc"
                      ? "⏶"
                      : "⏷"
                    : " ⏶"}
                </th>
                <th
                  style={{
                    width: "20%",
                    fontWeight: 600,
                    padding: "2px 4px",
                    verticalAlign: "middle",
                    cursor: "pointer",
                  }}
                  onClick={() => handleSort("taskName")}
                >
                  Task{" "}
                  {sortConfig.key === "taskName"
                    ? sortConfig.direction === "asc"
                      ? "⏶"
                      : "⏷"
                    : ""}
                </th>
                <th
                  style={{
                    width: "10%",
                    fontWeight: 600,
                    padding: "2px 4px",
                    verticalAlign: "middle",
                    cursor: "pointer",
                  }}
                  onClick={() => handleSort("priority")}
                >
                  Priority{" "}
                  {sortConfig.key === "priority"
                    ? sortConfig.direction === "asc"
                      ? "⏶"
                      : "⏷"
                    : ""}
                </th>
                <th
                  style={{
                    width: "10%",
                    fontWeight: 600,
                    padding: "2px 4px",
                    verticalAlign: "middle",
                    cursor: "pointer",
                  }}
                  onClick={() => handleSort("status")}
                >
                  Status{" "}
                  {sortConfig.key === "status"
                    ? sortConfig.direction === "asc"
                      ? "⏶"
                      : "⏷"
                    : ""}
                </th>
                <th
                  style={{
                    width: "45%",
                    fontWeight: 600,
                    padding: "2px 4px",
                    verticalAlign: "middle",
                  }}
                  onClick={() => handleSort("description")}
                >
                  Description{" "}
                  {sortConfig.key === "description"
                    ? sortConfig.direction === "asc"
                      ? "⏶"
                      : "⏷"
                    : ""}
                </th>
                <th
                  style={{
                    width: "5%",
                    padding: "2px 4px",
                    verticalAlign: "middle",
                  }}
                ></th>
                <th
                  style={{
                    width: "5%",
                    padding: "2px 4px",
                    verticalAlign: "middle",
                  }}
                ></th>
              </tr>
            </thead>
            <tbody>
              {currentData.length === 0 ? (
                <tr>
                  <td
                    colSpan="7"
                    className="text-center"
                    style={{ padding: "10px", fontSize: "12px" }}
                  >
                    No tasks available
                  </td>
                </tr>
              ) : (
                currentData.map((item, index) => (
                  <tr
                    key={item.id}
                    className="custom-table-row fnt12"
                    style={{
                      padding: "1px 0",
                      lineHeight: "0.6",
                      textAlign: "left",
                      verticalAlign: "middle",
                    }}
                  >
                    <td style={{ padding: "2px 4px", verticalAlign: "middle" }}>
                      {moment(item.dueDate).format("MM-DD-YYYY")}
                    </td>
                    <td style={{ padding: "2px 4px", verticalAlign: "middle" }}
                      title={item.taskName}>
                      {truncateText(item.taskName, 40)}
                    </td>
                    <td style={{ padding: "2px 4px", verticalAlign: "middle" }}>
                      {item.priority}
                    </td>
                    <td style={{ padding: "2px 4px", verticalAlign: "middle" }}>
                      {item.status === "InProgress"
                        ? "In Progress"
                        : item.status.charAt(0).toUpperCase() +
                        item.status.slice(1)}
                    </td>
                    <td
                      style={{ padding: "2px 4px", verticalAlign: "middle" }}
                      title={item.description}
                    >
                      {truncateText(item.description, 80)}
                    </td>
                    <td style={{ padding: "2px 4px", verticalAlign: "middle" }}>
                      <button
                        className="btn btn-link text-primary p-1"
                        onClick={() => handleEdit(item)}
                        style={{ fontSize: "14px" }}
                      >
                        <FaRegEdit />
                      </button>
                    </td>
                    <td style={{ padding: "2px 4px", verticalAlign: "middle" }}>
                      <button
                        className="btn btn-link text-danger p-1"
                        onClick={() => openDeleteModal(item.id)}
                        style={{ fontSize: "16px" }}
                      >
                        <RiDeleteBinLine />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {tasks?.length > 0 && (
        <div className="d-flex justify-content-between align-items-center mt-3 mb-2">
          <div>
            <label className="fnt12 fw-500 text-secondary">
              Rows per page:{" "}
            </label>
            <CustomSelect
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              options={[10, 25, 50, 100]} // The options for rows per page
            />

          </div>
          <div>
            <MdKeyboardArrowLeft
              className={` ${currentPage === 1 ? "disabled" : ""}`}
              onClick={() => {
                if (currentPage > 1) {
                  handlePageChange(currentPage - 1);
                }
              }}
              style={{
                cursor: "pointer",
                opacity: currentPage === 1 ? 0.5 : 1,
              }}
            />

            <span className="mx-2 fnt12 fw-500 text-secondary">
              Page {currentPage} of {totalPages}
            </span>

            <MdKeyboardArrowRight
              className={` ${currentPage === totalPages ? "disabled" : ""}`}
              onClick={() => {
                if (currentPage < totalPages) {
                  handlePageChange(currentPage + 1);
                }
              }}
              style={{
                opacity: currentPage === totalPages ? 0.5 : 1,
                cursor: "pointer",
              }}
            />
          </div>
        </div>
        )}
      </div>

      {/* Modals */}

      <DynamicModal
        heading="Tasks"
        isModalOpen={isModalOpen}
        id="deadlines-form"
        setIsModalOpen={setIsModalOpen}
        formData={formData}
        handleInputChange={handleInputChange}
        handleSave={handleSave}
        fields={deadlinesFieldsForamt}
        handleCloseModal={() => handleCloseModal(false)}
      />

      <Modal
        isOpen={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={handleDelete}
        title="Delete Task"
        message="Are you sure you want to delete this Task?"
        confirmText="Delete"
        cancelText="Cancel"
      />

      <SuccessPopup
        type={showSuccessPopup?.type}
        show={showSuccessPopup?.show}
        message={showSuccessPopup?.message}
        onClose={() => setShowSuccessPopup(false)}
      />
    </div>
  );
};

export default NotificationTable;
